import styled, { DefaultTheme } from 'styled-components'

import { DeprecatedText } from '@syconium/little-miss-figgy'

import { NextModalStyles } from '../../../../modals/NextModal'

export const Container = styled.div``

export function deriveModalStyles(theme: DefaultTheme): NextModalStyles {
  return {
    content: {
      borderRadius: 0,
      borderWidth: 0,
      bottom: 'initial',
      boxSizing: 'border-box',
      color: theme.color.deprecated.gray.darkest,
      left: 'initial',
      maxWidth: '460px',
      overflow: 'initial',
      padding: '24px 40px 40px',
      position: 'initial',
      right: 'initial',
      top: 'initial',
    },
    overlay: {
      backgroundColor: undefined,
    },
  }
}

export const Headline = styled(DeprecatedText)`
  line-height: 28px;
`

export const Instructions = styled(DeprecatedText)`
  margin: 16px 0 0;
`

export const Divider = styled.hr`
  border-width: 1px 0 0;
  border-color: ${o => o.theme.color.deprecated.stoneLight};
  border-style: solid;
  margin: 20px 0;
`

export const ProductTitle = styled(DeprecatedText)`
  margin-bottom: 20px;
`
